import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { InterEstateLeafBLListing } from './Pages'

export const InterEstateLeafBLRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={InterEstateLeafBLListing} />
    </Fragment>
)